const styles = `:host {
  gap: var(--goto-spacing-02);
  color: var(--goto-type-color-default);
  font: var(--goto-body-small);
  line-height: var(--goto-spacing-05);
}
:host .control {
  height: var(--goto-spacing-04);
  width: var(--goto-spacing-04);
  border-width: 1px;
  border-style: solid;
  border-color: var(--goto-border-color-default);
  background-color: var(--goto-surface-color-default);
}
:host .checked-indicator {
  height: var(--goto-spacing-02);
  width: var(--goto-spacing-02);
  background-color: var(--goto-surface-color-brand-default);
  inset: 3px;
}

:host([size=large]) {
  height: var(--goto-spacing-05);
  width: var(--goto-spacing-05);
}
:host([size=large]) .control {
  height: var(--goto-spacing-05);
  width: var(--goto-spacing-05);
}
:host([size=large]) .checked-indicator {
  height: 0.625rem;
  width: 0.625rem;
  inset: var(--goto-spacing-01);
}

:host(:not([disabled])) .control {
  border-width: 1px;
  border-style: solid;
  background-color: var(--goto-surface-color-default);
  border-color: var(--goto-border-color-default);
}
:host(:not([disabled])) .control:hover {
  background-color: var(--goto-interactive-color-secondary-hover);
  border-color: var(--goto-border-color-default);
}
:host(:not([disabled])) .control:active {
  background-color: var(--goto-interactive-color-secondary-pressed);
  border-color: var(--goto-border-color-default);
  box-shadow: none;
}
:host(:not([disabled])) .label {
  color: var(--goto-type-color-default);
}

:host(:focus-visible:not([disabled])) .control {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
  background-color: var(--goto-surface-color-default);
}

:host([aria-checked=true]:not([disabled])) .control {
  border-width: 1px;
  border-style: solid;
  background-color: var(--goto-interactive-color-secondary-default);
  border-color: var(--goto-border-color-default);
}
:host([aria-checked=true]:not([disabled])) .control:hover {
  border-width: 1px;
  border-style: solid;
  background-color: var(--goto-interactive-color-secondary-hover);
  border-color: var(--goto-border-color-default);
}
:host([aria-checked=true]:not([disabled])) .control:hover .checked-indicator {
  background: var(--goto-interactive-color-brand-default);
}
:host([aria-checked=true]:not([disabled])) .control:active {
  border-width: 1px;
  border-style: solid;
  background-color: var(--goto-interactive-color-secondary-pressed);
  border-color: var(--goto-border-color-default);
  box-shadow: none;
}
:host([aria-checked=true]:not([disabled])) .control:hover .checked-indicator {
  background: var(--goto-checkbox-checked-hover);
}
:host([aria-checked=true]:not([disabled])) .control:active .checked-indicator {
  background: var(--goto-checkbox-checked-pressed);
}

:host([aria-checked=true]:focus-visible:not([disabled])) .control {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
  background-color: var(--goto-surface-color-default);
}

:host([disabled]) {
  opacity: 1;
}
:host([disabled]) .control {
  border-width: 1px;
  border-style: solid;
  background-color: var(--goto-interactive-color-disabled);
  cursor: not-allowed;
}
:host([disabled]) .checked-indicator {
  background-color: var(--goto-icon-color-disabled);
}
:host([disabled]) .label {
  cursor: default;
  color: var(--goto-type-color-disabled);
}`; export default styles;